export default {
  importantNotification: {
    fetching: false,
    fetched: false,
    submitting: false,
    submitted: false,
    data: {}
  }
}
